import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { IonicStorageModule } from '@ionic/storage';
import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { Table } from '../pages/table/table';
import { Custom } from '../pages/custom/custom';
import { CustomDetail } from '../pages/custom/customdetail/customdetail';
import { List } from "../pages/list/list";
import { DetailPopoverMenu } from "../pages/detailPopoverMenu/detailPopoverMenu";
import { Detail } from "../pages/detail/detail";
import { ChartPage } from "../pages/chartpage/chartpage";
import { IFrame } from "../pages/iframe/iframe";
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { SocialSharing } from '@ionic-native/social-sharing';
import { HttpModule } from "@angular/http";
import { PdfViewerComponent } from 'ng2-pdf-viewer';
import { SafeHtml } from "../pipes/safeHTML";
import { SafeStyle } from "../pipes/safeStyle";
import { HeaderComponent } from "../components/header/header";
import { AudioCaptureComponent } from "../components/audio-capture/audio-capture";
import { ContactComponent } from "../components/contact/contact";
import { HomepageInformationComponent } from "../components/homepage-information/homepage-information";
import { HomepageTableComponent } from "../components/homepage-table/homepage-table";
import { HomepageChartComponent } from "../components/homepage-chart/homepage-chart";
import { AnimatesDirective, AnimationService } from "css-animator";
import { EbsWebServiceGlobals } from "../services/ebsWebServiceGlobals";
import { EbsWebService } from "../services/ebsWebService";
import { GridBoxComponent } from "../components/grid-box/grid-box";
import { EbsComponentService } from "../services/ebsComponentService";
import { GridBoxPage } from "../pages/grid-box/grid-box";
import { LoadImageFromStorage } from "../pipes/loadImageFromStorage";
import { DetectImages } from "../pipes/detectImages";
import { PdfViewerPage } from "../pages/pdf-viewer/pdf-viewer";
import { ScannerComponent } from "../components/scanner/scanner";
import { ScannerSortComponent } from "../components/scanner-sort/scanner-sort";
import { ScannerPage } from "../pages/scanner/scanner";
import { ScannerSortPage } from "../pages/scanner-sort/scanner-sort";
import { MessagePage } from "../pages/message/message";
import { CustomFooterPage } from "../components/custom-footer/custom-footer";
import { CustomHeaderPage } from "../components/custom-header/custom-header";
import { CustomBodyPage } from "../components/custom-body/custom-body";
import { NoticesPage } from "../components/notices/notices";
import { LoginPage } from "../pages/login/login";
import { EmailPage } from "../pages/email/email";
import { WhatsappPage } from "../pages/whatsapp/whatsapp";
import { DocumentViewer } from "@ionic-native/document-viewer";
import { HttpClientModule } from "@angular/common/http";
import { SharePdfPopover } from "../popovers/share-pdf/share-pdf";
import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import { IOSFilePicker } from '@ionic-native/file-picker';
import { File } from '@ionic-native/file';
import { Camera } from '@ionic-native/camera';
import { InputPage } from "../components/inputs/inputs";
import { TooltipComponent } from "../components/tooltip/tooltip";
import { CheckForFullWidth } from "../pipes/checkForFullWidth";
import { Signature } from "../pages/signature/signature";
import { SignaturePadModule } from 'angular2-signaturepad';
import { IonicImageViewerModule } from "ionic-img-viewer";
import { ProgressCircle } from "../components/progress-circle/progress-circle";
import { Replace } from "../pipes/replace";
import { MapToIterable } from "../pipes/mapToIterable";
import { BarcodeFunction } from '../functions/barcode';
import { Vibration } from '@ionic-native/vibration';
import { AndroidFullScreen } from '@ionic-native/android-full-screen';
import { ChartsModule } from 'ng2-charts';
import { VideoCaptureComponent } from '../components/video-capture/video-capture';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { FormsModule } from '@angular/forms';
import { CalendarDatePickerPopover } from '../popovers/date-picker/calendar-datepicker';
import { SpeechInputPopover } from '../popovers/speech-input/speech-input';
import { TablePopoverMore } from '../popovers/tablepopover-more/tablepopover-more';
import { TablePopoverLayout } from '../popovers/tablepopover-layout/tablepopover-layout';
import { FilePickerButton } from '../components/filepicker/filepicker';
import { DatePickerModule } from 'ionic-calendar-date-picker';
import { TreeviewPage } from '../pages/treeview/treeview';
import { TreeViewDetailModalPage } from '../pages/tree-view-detail-modal/tree-view-detail-modal';

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    Table,
    List,
    DetailPopoverMenu,
    Detail,
    ChartPage,
    IFrame,
    PdfViewerComponent,
    Custom,
    CustomDetail,
    SafeHtml,
    LoadImageFromStorage,
    SafeStyle,
    HeaderComponent,
    AudioCaptureComponent,
    VideoCaptureComponent,
    AnimatesDirective,
    GridBoxComponent,
    GridBoxPage,
    ContactComponent,
    HomepageInformationComponent,
    HomepageTableComponent,
    HomepageChartComponent,
    DetectImages,
    PdfViewerPage,
    ScannerComponent,
    ScannerSortComponent,
    ScannerPage,
    ScannerSortPage,
    MessagePage,
    CustomFooterPage,
    CustomHeaderPage,
    CustomBodyPage,
    NoticesPage,
    LoginPage,
    EmailPage,
    WhatsappPage,
    Signature,
    TablePopoverMore,
    CalendarDatePickerPopover,
    SpeechInputPopover,
    TablePopoverLayout,
    SharePdfPopover,
    InputPage,
    TooltipComponent,
    CheckForFullWidth,
    ProgressCircle,
    Replace,
    MapToIterable,
    FilePickerButton,
    TreeviewPage,
    TreeViewDetailModalPage
  ],
  imports: [
    DatePickerModule,
    NgxDatatableModule,
    BrowserModule,
    HttpModule,
    SignaturePadModule,
    HttpClientModule,
    IonicImageViewerModule,
    ChartsModule,
    IonicStorageModule.forRoot(),
    IonicModule.forRoot(MyApp, {
      platforms: {
        ios: {
          statusbarPadding: true
        }
      },
      mode: 'ios',
      backButtonText: '',
      iconMode: 'ios',
      modalEnter: 'modal-slide-in',
      modalLeave: 'modal-slide-out',
      tabsPlacement: 'bottom',
      pageTransition: 'ios-transition'
    }),
    AngularMultiSelectModule,
    FormsModule
  ],
  bootstrap: [IonicApp],
  schemas: [
    //NO_ERRORS_SCHEMA
  ],
  entryComponents: [
    MyApp,
    HomePage,
    Table,
    List,
    DetailPopoverMenu,
    Detail,
    ChartPage,
    IFrame,
    PdfViewerComponent,
    Custom,
    CustomDetail,
    GridBoxComponent,
    GridBoxPage,
    ContactComponent,
    HomepageInformationComponent,
    HomepageTableComponent,
    PdfViewerPage,
    ScannerComponent,
    ScannerSortComponent,
    ScannerPage,
    ScannerSortPage,
    MessagePage,
    CustomFooterPage,
    CustomBodyPage,
    LoginPage,
    EmailPage,
    WhatsappPage,
    Signature,
    TablePopoverMore,
    CalendarDatePickerPopover,
    SpeechInputPopover,
    TablePopoverLayout,
    SharePdfPopover,
    ProgressCircle,
    TreeviewPage,
    TreeViewDetailModalPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    AnimationService,
    EbsWebServiceGlobals,
    EbsWebService,
    EbsComponentService,
    DocumentViewer,
    BarcodeScanner,
    IOSFilePicker,
    BarcodeFunction,
    Vibration,
    AndroidFullScreen,
    SocialSharing,
    File,
    Camera,
    { provide: ErrorHandler, useClass: IonicErrorHandler }
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts